// ==================== src/store/store.js ====================
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import dashboardReducer from './slices/dashboardSlice';
import brandsReducer from './slices/brandsSlice';
import modalsReducer from './slices/modalsSlice';
import liveAffiliatesReducer from './slices/liveAffiliatesSlice';
import untappedOpportunitiesReducer from './slices/untappedOpportunitiesSlice';
import competitorReducer from './slices/competitorSlice';
import positionTrackerReducer  from './slices/positionTrackerSlice';
import termsCheckerReducer from './slices/termsCheckerSlice';
import gapBrandsReducer from './slices/gapBrandsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    brands: brandsReducer,
    modals: modalsReducer,
    liveAffiliates: liveAffiliatesReducer,
    untappedOpportunities: untappedOpportunitiesReducer,
    competitor: competitorReducer,
    positionTracker: positionTrackerReducer,
    termsChecker: termsCheckerReducer,
    gapBrands: gapBrandsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;